import debounce from "../helpers/debounce";

class Header {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.body = document.body;
        self.headerHeight = 0;
    }

    init() {
        let self = this;

        // On page load...
        window.addEventListener('load', evt => {
            // Set header height property on page load
            self.setHeightProperty();
        }, false);

        // Set header height property on window resize
        let debouncedFunction = debounce(function () {
            self.setHeightProperty();
        });

        window.addEventListener('resize', function () {
            debouncedFunction();
        }, false);
    }

    setHeightProperty() {
        let self = this;

        self.headerHeight = self.elem.offsetHeight;

        document.documentElement.style.setProperty("--header-height", self.headerHeight + 'px');
    }
}

export default Header;
